module.exports = __webpack_public_path__ + "img/main_westudy.121fcf49.png";